import { ApiComponentProductsQuiz } from '../types.wp'
import { DSNCProductsQuiz } from 'shared-definitions/types'

export function ncProductsQuiz(_input: ApiComponentProductsQuiz): DSNCProductsQuiz {
  return {
    resource: 'nc-products-quiz',
    title: 'Product Recommendation',
    iframeUrl: 'https://product-quiz-frontend-fe453ae67bf1.herokuapp.com',
    ipGetterApi: 'https://api.ipify.org/?format=json',
  }
}
